// frontend/src/lib/documentTitle.ts
// One <title> per route. Every route used to leave index.html's
// "SCOTUS Simulator" in place, so a tab strip, the history menu and a screen
// reader's window list all named eleven different pages identically.
//
// The shell (Chrome.tsx) names its routes from routeName() in a LAYOUT
// effect; a screen that knows something more specific (the case on a brief,
// summary, argument or share page) names itself in an ordinary effect, which
// React runs after every layout effect of the same commit, so the specific
// title always lands last.
import { useEffect } from 'react';

export const SITE_TITLE = 'SCOTUS Simulator';

/** "Page | SCOTUS Simulator", or the bare site name for no page. */
export function formatTitle(page?: string | null): string {
  const p = page?.trim();
  return p ? `${p} | ${SITE_TITLE}` : SITE_TITLE;
}

/**
 * Set document.title while this component is mounted. `null` or `undefined`
 * leaves the title alone (data still loading), so a screen does not flash the
 * generic name over the shell's route name before its case arrives. An empty
 * string means the bare site name, which is what the landing page uses.
 */
export function useDocumentTitle(page: string | null | undefined): void {
  useEffect(() => {
    if (page == null) return;
    document.title = formatTitle(page);
  }, [page]);
}
